// Should be replaced in the future with a better solution, but fine for now.
// export const REACT_APP_API_URL = "http://localhost:5000";
export const REACT_APP_API_URL = "/api"